module.exports = __webpack_public_path__ + "img/active-priority.2b2bd8d8.svg";